import { createMeta } from "../../../components/TapHeader";

const title = "Settings";
export const SettingsMeta = createMeta(title);
